export function slugify(str) {
  return String(str || '')
    .toLowerCase().trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function productSeoSlug(designer, sku) {
  const d = slugify(designer);
  const s = slugify(sku);
  if (d && s) return `${d}/${s}`;
  return d || s || '';
}

export function productUrl(product) {
  const slug = productSeoSlug(product.designer, product.sku);
  return slug ? `/shop/${slug}` : `/product/${product.id}`;
}